<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_TAG_TYPES } from './store'
import { ROUTES as TASK_TAG_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import TaskTagTable from './TaskTagTable'
import TaskTagCommonFilters from './TaskTagCommonFilters'
import TaskTagEdit from './TaskTagEdit.vue'

export default {
  name: 'TaskTagList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': TaskTagTable,
    'common-filters': TaskTagCommonFilters,
    'component-edit': TaskTagEdit,
    'component-detail': TaskTagEdit
  },
  data () {
    return {
      TASK_TAG_ROUTES,
      title: this.$t('Tags'),
      rolePerm: ['tasks_tasktag_list'],
      actionEnablePermission: ['tasks_tasktag_enable'],
      actionDisablePermission: ['tasks_tasktag_disable'],
      fieldName: 'name',
      searchFields: [
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 12 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.TASK_TAG_ROUTES.TASK_TAG_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('tasks_tasktag_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_TAG_TYPES.GENERIC.task['task-tag'].LIST.ACTIONS
    })
  }
}
</script>
